import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100vh;
	background-color: #f0f0f0;
`;

const Message = styled.div`
	font-size: 24px;
	color: #333;
	margin-top: 20px;
	text-align: center;
`;

const Svg = styled.svg`
	width: 150px;
	height: 150px;
`;

const NoAliasDataFound = () => {
	return (
		<Container>
			<Svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<circle cx="12" cy="12" r="10" />
				<line x1="12" y1="8" x2="12" y2="12" />
				<line x1="12" y1="16" x2="12.01" y2="16" />
			</Svg>
			<Message>No Alias Data Found</Message>
		</Container>
	);
};

export default NoAliasDataFound;
